import { event, config } from 'vue-gtag'

/**
 * Track page views manually (useful for SPAs)
 */
export function trackPageView(pageTitle?: string, pagePath?: string) {
  if (!import.meta.env.VITE_GA_MEASUREMENT_ID) {
    console.log('Analytics Page View (Dev Mode):', pageTitle, pagePath)
    return
  }

  config({
    page_title: pageTitle,
    page_location: pagePath || window.location.href,
  })
}

/**
 * Track custom events (simplified)
 */
export function trackEvent(eventName: string, parameters?: Record<string, any>) {
  if (!import.meta.env.VITE_GA_MEASUREMENT_ID) {
    console.log('Analytics Event (Dev Mode):', eventName, parameters)
    return
  }

  event(eventName, parameters || {})
}